import { render, staticRenderFns } from "./multiple_autocomplete.vue?vue&type=template&id=222f7822&"
import script from "./multiple_autocomplete.vue?vue&type=script&lang=js&"
export * from "./multiple_autocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports